import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../environments/environment';
import { Observable, throwError } from 'rxjs';
import Keycloak from 'keycloak-js';

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const keycloak = inject(Keycloak);
  if (!keycloak.authenticated) {
    return next(req);
  }
  if (req.url.startsWith(`${environment.apiUrl}/v1/ikp/auth`) || req.url.startsWith(environment.keycloakUrl)) {
    if (keycloak.isTokenExpired()) {
      keycloak
        .updateToken()
        .then(isRefreshed => {
          if (!isRefreshed) {
            keycloak.login();
          }
        })
        .catch(() => {
          return throwError(() => new HttpErrorResponse({ status: 401 }));
        });
    }
    const authReq = req.clone({
      headers: req.headers.set('Authorization', `Bearer ${keycloak.token}`),
    });
    return next(authReq);
  } else {
    return next(req);
  }
}
